module.exports = __webpack_public_path__ + "static/media/medixine-online-screen-sm@2x.8b43bcea.png";